export function formatTime(timestamp) {
  if (!timestamp) return null;

  const date = new Date(timestamp);
  if (isNaN(date)) return null;

  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
}